import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import soundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";

export default class BonusWheelPromptTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        return new Contract<void>(resolve => {
            setTimeout(() => soundManager.customEvent("plaque_exit"), 2000);
            resolve(null);
        });
    }
}